import { defineActionGroup } from 'rd-redux-utils';

export const confirmationModalActionGroup = defineActionGroup(
  'COnFIRMATION_MODALS_GROUP'
);

export const setConfirmationModalAction = confirmationModalActionGroup.defineAction<{
  payload: boolean;
}>('SET CONFIRMATION MODAL');
